export default __webpack_public_path__ + "static/media/linkedin.7858c3d3.svg";